import {TranslatorScope} from '../../locale/types'
import {theme} from '../../theme/theme'
import {omit, optionsToMapObject} from '../../utils/logic'
import {SubscriptionDurationTypeEnum, SubscriptionPriceTypesEnum} from './types'

type SubscriptionPriceTypeOptionsType = {
  label: TranslatorScope
  value: SubscriptionPriceTypesEnum
}

export const SUBSCRIPTION_PRICE_TYPE_OPTIONS: SubscriptionPriceTypeOptionsType[] = [
  {
    label: 'weekly',
    value: 2,
  },
  {
    label: 'monthly',
    value: 2,
  },
  {
    label: 'yearly',
    value: 3,
  },
  {
    label: 'oneTimePayment',
    value: 0,
  },
]

export const SUBSCRIPTION_PRICE_TYPE_MAP = optionsToMapObject(SUBSCRIPTION_PRICE_TYPE_OPTIONS, (obj) => omit(obj, ['value']))

type SubscriptionDurationTypeOption = {
  label: TranslatorScope,
  dateFormatKey?: 'days' | 'hours' | 'minutes' | 'months' | 'seconds' | 'weeks' | 'years' | undefined,
  profileLabel: TranslatorScope,
  value: SubscriptionDurationTypeEnum | 'IN_TOTAL',
  font?: keyof typeof theme.colors,
  bg?: keyof typeof theme.colors,
}

export const SUBSCRIPTION_FREQUENCY_TYPE_IN_TOTAL = 'IN_TOTAL'

export const SUBSCRIPTION_DURATION_TYPE_OPTIONS: SubscriptionDurationTypeOption[] = [
  {
    label: 'days',
    dateFormatKey: 'days',
    profileLabel: 'days',
    value: SubscriptionDurationTypeEnum.DAYS,
    font: 'subscriptionGreenFont',
    bg: 'subscriptionGreenBackground',
  },
  {
    label: 'weeks',
    dateFormatKey: 'weeks',
    profileLabel: 'weekly',
    value: SubscriptionDurationTypeEnum.WEEKS,
    font: 'subscriptionGreenFont',
    bg: 'subscriptionGreenBackground',
  },
  {
    label: 'months',
    dateFormatKey: 'months',
    profileLabel: 'month',
    value: SubscriptionDurationTypeEnum.MONTHS,
    font: 'subscriptionPurpleFont',
    bg: 'subscriptionPurpleBackground',
  },
  {
    label: 'years',
    dateFormatKey: 'years',
    profileLabel: 'year',
    value: SubscriptionDurationTypeEnum.YEARS,
    font: 'subscriptionBlueFont',
    bg: 'subscriptionBlueBackground',
  },
  {
    label: 'in_total',
    profileLabel: 'in_total',
    value: SUBSCRIPTION_FREQUENCY_TYPE_IN_TOTAL,
  },
]

export const SUBSCRIPTION_DURATION_TYPE_MAP = optionsToMapObject(SUBSCRIPTION_DURATION_TYPE_OPTIONS, (obj) => omit(obj, ['value']))